import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Typography, CircularProgress } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


const MyTable = ({
    data,
    handleMenuOpen,
    handleMenuOpenAtividade,
    handleClickIncomplets,
    setOpenAddPoint,
    countColumns,
    handleOpenADDpoint,
    loadingHistory,
    startLoading,
    idCreatedTimesheet,
    setOpenHistory,
    historyModal
}) => {
    const columns = () => {
        const tabelas = [];
        if (countColumns > 4) {
            countColumns = 4
        }

        for (let i = 0; i < countColumns; i++) {
            tabelas.push(
                <>
                    <TableCell style={styles.TableCellColum}>Entrada</TableCell>
                    <TableCell style={styles.TableCellColum}>Saída</TableCell>
                </>
            );
        }

        return tabelas;
    }


    //@A função recebe dois argumentos: row, que contém os turnos, e countColumns, que define o número máximo de colunas a serem criadas
    const timeClocks = (row, countColumns) => {
        const timeclocks = [];
        const cellStyle = { padding: '0', margin: '0', verticalAlign: 'middle', lineHeight: '1', fontSize: '14px', textAlign: 'center' };

        //A função createCell é definida dentro de timeClocks. Ela retorna uma célula de tabela com um botão que,
        // quando clicado, aciona um manipulador de eventos. O botão exibe o horário do turno ou ‘–:–’ se o horário não estiver disponível.
        const createCell = (clock, eventHandler, color, time, row, type, index) => (
            <TableCell style={cellStyle}>
                <Button
                    className="cell"
                    onClick={(event) => eventHandler(event, clock, row, type, clock.timeclockId ? null : index)}
                    endIcon={time ? <MoreVertIcon style={{ color: 'gray', fontSize: '16px' }} /> : null}
                >
                    {
                        loadingHistory.timeclockId && (loadingHistory.timeclockId == clock.timeclockId) && loadingHistory.isLoading ||
                            (loadingHistory.dtRef == row.dtRef) && (loadingHistory.type == type) && (loadingHistory.index == index) && loadingHistory.isLoading ?
                            <CircularProgress size={30} style={{ marginLeft: '20px', marginTop: '4px' }} />
                            :
                            <Typography variant="outlined" style={{ color }}>{time ? time : '--:--'}</Typography>
                    }
                </Button>
            </TableCell>
        );

        //A função então percorre os turnos na row e cria uma célula para cada ponto de entrada e saída. Se um turno não tiver um ponto de entrada ou saída, uma célula vazia é criada.
        const columnsCount = row.shifts.length > 0 ? row.shifts.length : countColumns
        if (countColumns > 4) {
            countColumns = 4
        }
        for (let i = 0; i < columnsCount; i = i + 2) {
            if (timeclocks.length < 8) {
                let clockIn = row.shifts[i] && row.shifts[i].type === "Entrada" ? row.shifts[i] : {};
                let clockOut = row.shifts[i + 1] && row.shifts[i + 1].type === "Saída" ? row.shifts[i + 1] : row.shifts[i] && row.shifts[i].type === "Saída" ? row.shifts[i] : {};

                let colorIn = clockIn.clockIn ? (clockIn.eventsLocation ? '#ff9801' : '#50535b') : 'red';
                let colorOut = clockOut.clockOut ? (clockOut.eventsLocation ? '#ff9801' : '#50535b') : 'red';

                timeclocks.push(createCell(clockIn ? clockIn : row, clockIn.clockIn ? handleMenuOpen : handleOpenADDpoint, colorIn, clockIn.clockIn || '', row, "Entrada", i));
                timeclocks.push(createCell(clockOut ? clockOut : row, clockOut.clockOut ? handleMenuOpen : handleOpenADDpoint, colorOut, clockOut.clockOut || '', row, "Saída", i));
            }
        }

        // Se o número de células criadas for menor que o dobro de countColumns, preencha com células vazias
        let index = 0;
        while (timeclocks.length < 2 * countColumns) {
            timeclocks.push(createCell({}, setOpenAddPoint, 'red', '', row, "Entrada", new Date().getTime(), index));
            index++;
            timeclocks.push(createCell({}, setOpenAddPoint, 'red', '', row, "Saída", new Date().getTime(), index));
            index++;
        }

        return timeclocks;
    };
    const getDescription = (row) => {
        if (row.complete) {
            return row.isSchedule ? 'HORAS TRABALHADAS: ' + row.totalWorkingInMinutes : row.description;
        } else if (row.isHolidays || row.allowancesAndDaysOff?.displayValue) {
            return '';
        } else if (row.isSchedule && !row.isScheduleRotation) {
            return 'Pontos ausentes';
        } else if (row.isScheduleRotation) {
            return 'HORAS TRABALHADAS: ' + row.totalWorkingInMinutes
        }
        return '';
    };

    function FormattedDate({ date }) {
        const [day, weekDay] = date.split(' - ');
        return (
            <div>
                <Typography style={styles.viewDate}>{day}</Typography>
                <Typography style={styles.viewDate}>{weekDay}</Typography>
            </div>
        );
    }

    return (
        <TableContainer component={Paper} style={styles.TableContainer}>
            <Table style={{ width: '100%' }}>
                <TableHead>
                    <TableRow>
                        <TableCell style={styles.TableCellColum}>Data</TableCell>
                        {columns()}
                        <TableCell style={styles.TableCellColum}>
                            <div style={{ marginLeft: '50px' }}>Atividade</div>
                        </TableCell>

                        <TableCell style={styles.TableCellColum}>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' }}>
                            <TableCell style={styles.TableCellDate}>
                                <Button
                                    onClick={() => historyModal(row)}
                                >
                                    <FormattedDate date={row.data} />
                                </Button>
                            </TableCell>
                            {timeClocks(row, countColumns)}

                            <TableCell style={styles.TableCellActivit}>
                                <Button
                                    className="cell"
                                    onClick={() => historyModal(row)}
                                >
                                    <div >
                                        {<MoreVertIcon className="icon" style={styles.Icon} />}
                                    </div>
                                </Button>
                                <Typography
                                    className="cell"
                                    style={{
                                        backgroundColor: row.complete ? null : row.isSchedule ? row.allowancesAndDaysOff?.displayValue ? null : row.isHolidays ? null : row.isScheduleRotation ? null : '#e01b38' : null,
                                        color: row.isScheduleRotation ? 'black' : row.complete || row.isHolidays || row.allowancesAndDaysOff?.displayValue ? row.isHolidays ? '#537ccd' : 'black' : 'white',
                                        fontSize: row.complete || row.isHolidays ? '11px' : '12px',
                                        lineHeight: '1',
                                        width: '200%',
                                        height: '150%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {row.shifts.length > 8 ?
                                        <Button
                                            className="cell"
                                            onClick={(event) => handleClickIncomplets(event, row)}
                                            style={styles.ButtonView}
                                        >
                                            Ver mais pontos
                                        </Button>
                                        :
                                        <div>
                                            <p style={{ fontSize: 12, fontWeight: 'bold' }}>
                                                {getDescription(row)}
                                            </p>
                                            {row.isHolidays && <p style={{ fontSize: 12 }}>{row.isHolidays}</p>}
                                            {row.allowancesAndDaysOff?.displayValue && <p style={{ fontSize: 12 }}>{row.allowancesAndDaysOff.displayValue}</p>}
                                        </div>

                                    }


                                </Typography>
                            </TableCell>



                            <TableCell style={styles.status}>
                                <div className="icon-container">
                                    {row.complete ? <FiberManualRecordIcon className="icon" style={{ color: row.events ? '#ff9801' : row.isHolidays ? '#537ccd' : 'green', fontSize: '14px' }} /> : row.isSchedule ? <FiberManualRecordIcon className="icon" style={{ color: row.events ? '#ff9801' : row.isHolidays ? '#537ccd' : 'red', fontSize: '14px' }} /> : null}
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer >
    );
};

export default MyTable;

const styles = ({
    TableContainer: {
        maxWidth: '90%',
        overflow: 'auto',
        marginLeft: '-10px'
    },
    TableCellColum: {
        fontSize: '12px',
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#464a54'
    },
    TableCellDate: {
        padding: '0',
        lineHeight: '0',
        fontSize: '14px',
        marginLeft: '15px',
        textAlign: 'left'
    },
    TableCellActivit: {
        display: 'flex',
        padding: '6px',
        alignItems: 'center',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    viewDate: {
        fontSize: '12px',
        color: '#50535b',
        fontWeight: 'bold'
    },
    Icon: {
        color: '#50535b',
        fontSize: '16px'
    },
    ButtonView: {
        color: 'white',
        fontSize: 9,
        backgroundColor: '#537ccd',
        fontWeight: 'bold'
    },
    status: {
        padding: '0',
        margin: '0',
        verticalAlign: 'middle',
        lineHeight: '0',
        fontSize: '14px',
        textAlign: 'center'
    }
})